import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { CopyTextToClipboardModule } from '../copy-text-to-clipboard/copy-text-to-clipboard.module';
import { EmailViewerComponent } from './email-viewer.component';
import { SvgIconModule } from '../svg-icon/svg-icon.module';
import { EmailAttachmentsModule } from '../email-attachments/email-attachments.module';
import { SecureFrameModule } from '../secure-frame/secure-frame.module';

@NgModule({
  imports: [
    CommonModule,
    TranslateModule.forChild(),
    SvgIconModule,
    CopyTextToClipboardModule,
    EmailAttachmentsModule,
    SecureFrameModule
  ],
  declarations: [
    EmailViewerComponent
  ],
  exports: [
    EmailViewerComponent
  ]
})
export class EmailViewerModule {}
